module.exports = __webpack_public_path__ + "img/client-bia.c8c7c6d5.png";